// The "comic pop" look as plain style objects, for the pages that style inline (the
// class version lives in fp-ui.css). They are meant to be spread LAST inside a page's
// own style block, so they restyle it without touching its layout:
//
//   header: { ...what the page already had, ...fpHeader },

// Top bar of an inner page.
export const fpHeader = {
  padding: '10px 14px 12px',
  backgroundColor: '#22104a',
  borderBottom: '3px solid #000',
  boxShadow: '0 3px 0 #ff2d95, 0 8px 16px rgba(0, 0, 0, 0.45)',
  position: 'sticky',
  top: 0,
  zIndex: 50,
};

// Round "back" button of the top bar (and its twin on the right, when there is one).
export const fpBackButton = {
  width: '42px',
  height: '42px',
  padding: 0,
  flexShrink: 0,
  background: 'linear-gradient(180deg, #ff7ac0 0%, #ff2d95 55%, #d4127a 100%)',
  border: '3px solid #000',
  boxShadow: '0 4px 0 #000, inset 0 2px 0 rgba(255, 255, 255, 0.55)',
};

// Title in the top bar.
export const fpHeaderTitle = {
  fontSize: '17px',
  fontWeight: 900,
  fontStyle: 'italic',
  letterSpacing: '0.5px',
  textTransform: 'uppercase',
  color: '#fff',
  textShadow: 'var(--fp-outline)',
};

// A content card: keeps its own colour, gets the black outline and the hard shadow.
export const fpCard = {
  border: '3px solid #000',
  boxShadow: '0 6px 0 #000, 0 12px 22px rgba(0, 0, 0, 0.35)',
};

// A button: keeps its own colour, gets the sticker outline. (The press-down movement
// comes from fp-ui.css, for every button of the app.)
export const fpSticker = {
  border: '3px solid #000',
  boxShadow: '0 5px 0 #000, inset 0 2px 0 rgba(255, 255, 255, 0.45)',
  fontWeight: 900,
};

// Same, for small buttons and chips.
export const fpStickerSmall = {
  border: '2.5px solid #000',
  boxShadow: '0 3px 0 #000, inset 0 2px 0 rgba(255, 255, 255, 0.45)',
};
